import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4c5ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-settings-topbar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-title" }, "⚙️ Settings", -1 /* HOISTED */))
const _hoisted_3 = { class: "nge-settings-content" }
const _hoisted_4 = {
  key: 0,
  class: "nge-set-viewas"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-set-viewas-label" }, "See the game as", -1 /* HOISTED */))
const _hoisted_6 = {
  class: "nge-set-viewas-seg",
  role: "radiogroup",
  "aria-label": "See the game as"
}
const _hoisted_7 = ["aria-checked"]
const _hoisted_8 = ["aria-checked"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-set-viewas-hint" }, "Player view hides admin buttons and tabs, so you see Pyr as players do. It works straight away, with no Save, and your admin powers stay. Waiting admin notifications show as a red dot on the Player view label in the top bar; click that label to come back.", -1 /* HOISTED */))
const _hoisted_10 = { class: "nge-set-col nge-set-col--identity" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-set-col-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-set-col-title" }, "Identity"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-set-col-sub" }, "who you are")
], -1 /* HOISTED */))
const _hoisted_12 = ["aria-expanded"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, " How you appear in chat, and how others tag you. 3-20 characters, letters/numbers/underscore, no spaces. ", -1 /* HOISTED */))
const _hoisted_15 = { class: "nge-settings-username-display" }
const _hoisted_16 = ["aria-expanded"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Pick your country or the EyeWire logo.", -1 /* HOISTED */))
const _hoisted_19 = { class: "nge-settings-country-flag-cell" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 2,
  class: "nge-settings-country-flag-placeholder"
}
const _hoisted_23 = { class: "nge-settings-country-name" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-country-caret" }, "▾", -1 /* HOISTED */))
const _hoisted_25 = {
  key: 0,
  class: "nge-settings-country-dropdown"
}
const _hoisted_26 = { class: "nge-settings-country-list" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "nge-settings-country-opt-flag" }
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "nge-settings-country-opt-name" }
const _hoisted_32 = {
  key: 0,
  class: "nge-settings-country-empty"
}
const _hoisted_33 = ["aria-expanded"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Share a little about yourself with the community.", -1 /* HOISTED */))
const _hoisted_36 = ["aria-expanded"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Chat, help requests and the counts on your top bar icons.", -1 /* HOISTED */))
const _hoisted_39 = { class: "nge-settings-toggle" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Mute the chat unread count", -1 /* HOISTED */))
const _hoisted_41 = { class: "nge-settings-toggle" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Fade chat when I click away", -1 /* HOISTED */))
const _hoisted_43 = {
  class: "nge-settings-toggle",
  title: "A thin bar marks your own messages in chat, so they are easy to find when you scroll back. Switch off to hide it."
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Mark my own messages in chat", -1 /* HOISTED */))
const _hoisted_45 = { class: "nge-settings-toggle" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Mute help requests", -1 /* HOISTED */))
const _hoisted_47 = {
  class: "nge-settings-toggle",
  title: "Undelete brings back cells you removed from view. On: its icon shows how many steps it can bring back."
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show a counter on the Undelete icon", -1 /* HOISTED */))
const _hoisted_49 = ["aria-expanded"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "What opens when you switch to a dataset.", -1 /* HOISTED */))
const _hoisted_52 = { class: "nge-settings-toggle" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Open datasets without the starter cells (loads faster)", -1 /* HOISTED */))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint nge-sv-hint" }, "Show in the dataset selector: extra datasets to explore. There is nothing to proofread or claim in them.", -1 /* HOISTED */))
const _hoisted_55 = ["checked", "onChange"]
const _hoisted_56 = { class: "nge-settings-toggle-label" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint nge-sv-hint" }, "Your own start view: pick a dataset and paste a share link made in it. It opens instead of the starter view whenever you switch there.", -1 /* HOISTED */))
const _hoisted_58 = { class: "nge-sv-row" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "nge-sv-row" }
const _hoisted_61 = {
  key: 0,
  class: "nge-sv-error"
}
const _hoisted_62 = {
  key: 1,
  class: "nge-sv-list"
}
const _hoisted_63 = { class: "nge-sv-name" }
const _hoisted_64 = ["title"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Click Save below to keep these.", -1 /* HOISTED */))
const _hoisted_67 = { class: "nge-set-col nge-set-col--topbar" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-set-col-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-set-col-title" }, "Display"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-set-col-sub" }, "what you see")
], -1 /* HOISTED */))
const _hoisted_69 = ["aria-expanded"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Toggle which actions appear in your top bar.", -1 /* HOISTED */))
const _hoisted_72 = { class: "nge-settings-toolbar-grid" }
const _hoisted_73 = ["title", "onClick"]
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = ["src", "alt"]
const _hoisted_76 = {
  key: 2,
  class: "nge-settings-toolbar-emoji"
}
const _hoisted_77 = { class: "nge-settings-toolbar-label" }
const _hoisted_78 = ["aria-expanded"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "How cells look in 3D.", -1 /* HOISTED */))
const _hoisted_81 = {
  class: "nge-settings-toggle nge-settings-pick",
  title: "How the cell under your mouse stands out in 3D. Saturate: the cell's colour turns richer and it is lit from within, so even a bright colour stands out. Spotlight: the cell turns a little richer and the other cells in 3D dim, so it stands out gently. Fade: the original look, the cell turns pale. Halo: a slim glowing line around its edges. Pulse: when you point at it, a ring of light runs out along it from your mouse, like a signal firing. Hologram: the cell turns into cyan light (or your pulse colour), glowing brightest at its edges, with a soft glow around it. Metallic: a dark, shiny cell with bright edges. None: nothing marks it. In 2D the cell keeps its own colour, at your Render opacity. Highlight on hover itself is switched on and off in the Render tab of the 3D layer."
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "3D Hover", -1 /* HOISTED */))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "halo" }, "Halo", -1 /* HOISTED */))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "saturate" }, "Saturate", -1 /* HOISTED */))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "spotlight" }, "Spotlight", -1 /* HOISTED */))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "fade" }, "Fade (original)", -1 /* HOISTED */))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "pulse" }, "Pulse", -1 /* HOISTED */))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "hologram" }, "Hologram", -1 /* HOISTED */))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "metallic" }, "Metallic", -1 /* HOISTED */))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "none" }, "None", -1 /* HOISTED */))
const _hoisted_91 = [
  _hoisted_83,
  _hoisted_84,
  _hoisted_85,
  _hoisted_86,
  _hoisted_87,
  _hoisted_88,
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = {
  class: "nge-settings-toggle nge-settings-pick nge-pulse-color",
  title: "The colour of the light that runs along the cell, with the Pulse look and with the P key."
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Pulse colour", -1 /* HOISTED */))
const _hoisted_94 = { class: "nge-pulse-swatches" }
const _hoisted_95 = ["title", "aria-label", "onClick"]
const _hoisted_96 = ["value"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint nge-pulse-hint" }, [
  /*#__PURE__*/_createTextVNode("Press "),
  /*#__PURE__*/_createElementVNode("b", null, "P"),
  /*#__PURE__*/_createTextVNode(" with your mouse over a cell in 3D to send a pulse along it, whichever look you choose.")
], -1 /* HOISTED */))
const _hoisted_98 = {
  key: 0,
  class: "nge-settings-toggle",
  title: "For Halloween, the Sandbox's starting cell wears a jack o' lantern over its cell body. Off: no pumpkin."
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show the Halloween pumpkin on the Sandbox cell", -1 /* HOISTED */))
const _hoisted_100 = ["aria-expanded"]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Celebrations, motion, and what else shows on screen.", -1 /* HOISTED */))
const _hoisted_103 = {
  class: "nge-settings-toggle",
  title: "On: completing a cell or submitting a Quest brings up the congratulations, with confetti. Off: nothing comes up; the cell still shows as Proofread in its menu and in the segment list, and a Quest still counts."
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Cell & Quest celebration", -1 /* HOISTED */))
const _hoisted_105 = {
  class: "nge-settings-toggle",
  title: "On: an achievement you earn comes up as a card in the middle of the screen, with confetti. Off: nothing comes up; it is still in your Trophy Case and in the bell."
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Achievement celebration", -1 /* HOISTED */))
const _hoisted_107 = {
  class: "nge-settings-toggle",
  title: "Off: every notification in one list. On: tabs in the bell, My Pyr for what was sent to you and Pyr Updates for what went to everyone (and Admin, for admins)."
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Organize my notifications into categories", -1 /* HOISTED */))
const _hoisted_109 = {
  class: "nge-settings-toggle",
  title: "Today in Pyr is the short note each afternoon on what changed in Pyr that day. Off: it no longer comes to your bell. Other announcements still do."
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show Today in Pyr daily updates", -1 /* HOISTED */))
const _hoisted_111 = {
  class: "nge-settings-toggle",
  title: "On: a small burst of particles where your point lands, when you place a Highlight, Tag, cut, merge or Find Path point. Off: the points go down with no particles."
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Particles", -1 /* HOISTED */))
const _hoisted_113 = {
  class: "nge-settings-toggle",
  title: "Stops the animations and takes away the glows around text, buttons and panels, for a quieter screen. The cells and the 3D view stay as they are. A few small animations follow after a reload."
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Calm screen: no animations or glows", -1 /* HOISTED */))
const _hoisted_115 = {
  class: "nge-settings-toggle",
  title: "A bigger target cursor over the 2D and 3D views, easier to find on a large screen."
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Extra large cursor", -1 /* HOISTED */))
const _hoisted_117 = {
  class: "nge-settings-toggle",
  title: "Makes the text in Pyr's windows (your profile, Settings, the Cell Library, the bell, the leaderboard) and in the layer side panel a fifth bigger, with everything around it, so it is easier to read. The 2D and 3D views stay as they are."
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Large text", -1 /* HOISTED */))
const _hoisted_119 = {
  class: "nge-settings-toggle",
  title: "The top bar tucks away, so the views get the whole window. Move the mouse to the top edge to bring it back, or press the \\ key. Your unread notifications show as a small bell in the corner of the 3D view. It stays put on a touch screen, during a tutorial, and while new icons are still arriving."
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Magic Top Bar", -1 /* HOISTED */))
const _hoisted_121 = {
  class: "nge-settings-toggle",
  title: "A cell with a cell type shows the type in the segment list. On: its segment ID is written under the type too. Off: the type alone; the ID is in the hover tip and on the copy button."
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show the segment ID under a cell's label", -1 /* HOISTED */))
const _hoisted_123 = {
  class: "nge-settings-toggle",
  title: "The speaker in the bottom right corner plays EyeWire Radio. Off: no speaker."
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show the sound icon (EyeWire Radio)", -1 /* HOISTED */))
const _hoisted_125 = { class: "nge-set-col nge-set-col--viewer" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-set-col-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-set-col-title" }, "Viewer"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-set-col-sub" }, "how it works")
], -1 /* HOISTED */))
const _hoisted_127 = ["aria-expanded"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "What happens when you jump to a cell or come back.", -1 /* HOISTED */))
const _hoisted_130 = {
  class: "nge-settings-toggle",
  title: "Off: a jump shows only the cell you jumped to. On: each jump adds its cell to the ones already in your view."
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Jumping to a cell adds it to my view (off: it replaces my view)", -1 /* HOISTED */))
const _hoisted_132 = { class: "nge-settings-toggle" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Keep my display settings (opacity, layout, highlight on hover) when jumping to cells", -1 /* HOISTED */))
const _hoisted_134 = {
  class: "nge-settings-toggle",
  title: "Your view is saved as you work. When a dataset opens, a small bar offers to bring it back. Never shown on the Sandbox."
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Offer to pick up where I left off when a dataset opens", -1 /* HOISTED */))
const _hoisted_136 = {
  class: "nge-settings-toggle nge-settings-pick",
  title: "The tab the Cell Library shows first each time you open it. Shift+L opens and closes the library."
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Cell Library opens on", -1 /* HOISTED */))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "mine" }, "My Cells", -1 /* HOISTED */))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "available" }, "Available", -1 /* HOISTED */))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "claimed" }, "Claimed", -1 /* HOISTED */))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "All", -1 /* HOISTED */))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "help" }, "Help", -1 /* HOISTED */))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "links" }, "My Links", -1 /* HOISTED */))
const _hoisted_144 = [
  _hoisted_138,
  _hoisted_139,
  _hoisted_140,
  _hoisted_141,
  _hoisted_142,
  _hoisted_143
]
const _hoisted_145 = ["aria-expanded"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "How sharp the 2D images are, and where they load from.", -1 /* HOISTED */))
const _hoisted_148 = {
  class: "nge-settings-toggle nge-settings-pick",
  title: "How sharp the 2D images are drawn. Half loads about a quarter of the data and Quarter about a sixteenth, so they load much faster on a slow connection, but the images stay that blurry until you set Full again."
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "2D image detail", -1 /* HOISTED */))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Full (sharpest)", -1 /* HOISTED */))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Half (faster loading)", -1 /* HOISTED */))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 4 }, "Quarter (fastest, blurry)", -1 /* HOISTED */))
const _hoisted_153 = [
  _hoisted_150,
  _hoisted_151,
  _hoisted_152
]
const _hoisted_154 = {
  class: "nge-settings-toggle nge-settings-pick",
  title: "Where the 2D images come from. Copies hosted in Asia exist for EyeWire II Retina, MEC and the Sandbox; other datasets always load from the Americas. Automatic times both copies once and uses the faster one for you. Shared links and saved views open on your choice."
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "2D images load from", -1 /* HOISTED */))
const _hoisted_156 = { value: "auto" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "americas" }, "Americas", -1 /* HOISTED */))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "asia" }, "Asia", -1 /* HOISTED */))
const _hoisted_159 = ["aria-expanded"]
const _hoisted_160 = ["aria-expanded"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-set-fold-chev",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-set-info-title" }, "What is neuroglancer?", -1 /* HOISTED */))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Neuroglancer is a connectomics proofreading platform made by Google that Pyr is built on. It draws the 2D images and the 3D cells you work on. Scientists also use it (without the fancy Pyr interface).", -1 /* HOISTED */))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Settings here bring back its original, and dare we say unintuitive, user interface elements. This section brings back legacy neuroglancer elements and advanced settings.", -1 /* HOISTED */))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Neuroglancer's own controls and panels.", -1 /* HOISTED */))
const _hoisted_166 = { class: "nge-settings-toggle" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show point annotations as Pyr gems in 3D", -1 /* HOISTED */))
const _hoisted_168 = {
  class: "nge-settings-toggle",
  title: "Off: a click on a layer tab, or its number key (1 to 9), makes it the active layer; a right click, or Shift + the number, hides or shows it. On: a click or the number hides or shows it, as in neuroglancer."
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Classic Layers (Click to hide)", -1 /* HOISTED */))
const _hoisted_170 = {
  class: "nge-settings-toggle",
  title: "Off: clicking the 2D EM layer's tab shows or hides the 2D view. On: it opens the layer's side panel (Source, Rendering, Annotations), as in neuroglancer."
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Clicking the 2D image layer opens its side panel", -1 /* HOISTED */))
const _hoisted_172 = { class: "nge-settings-toggle" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show Source and Rendering tabs on annotation layers", -1 /* HOISTED */))
const _hoisted_174 = {
  class: "nge-settings-toggle",
  title: "Segmentation layers open on Segments. Turn this on to also see their Source and Graph tabs. Takes effect when the page reloads."
}
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show Source and Graph tabs on segmentation layers", -1 /* HOISTED */))
const _hoisted_176 = {
  class: "nge-settings-toggle",
  title: "The round (?) button at the top right of the viewer opens neuroglancer's own list of keyboard and mouse controls. Many of them are out of date and do not match Pyr. For Pyr's own keys, open Keyboard shortcuts in the menu at the top right, or press Ctrl+K and type keys."
}
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Show the neuroglancer controls button (?)", -1 /* HOISTED */))
const _hoisted_178 = {
  class: "nge-settings-toggle",
  title: "The x y z letters in the top left of each view. Point at them for neuroglancer's scale and depth panel."
}
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "xyz top left", -1 /* HOISTED */))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px"} }, null, -1 /* HOISTED */))
const _hoisted_181 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Active logins:", -1 /* HOISTED */))
const _hoisted_183 = { class: "nge-settings-login-info" }
const _hoisted_184 = { class: "nge-settings-login-email" }
const _hoisted_185 = { class: "nge-settings-login-host" }
const _hoisted_186 = ["onClick"]
const _hoisted_187 = { class: "nge-settings-actions" }
const _hoisted_188 = { key: 0 }
const _hoisted_189 = { key: 1 }
const _hoisted_190 = { class: "nge-settings-reset-row" }
const _hoisted_191 = {
  class: "nge-settings-reset-dlg",
  role: "alertdialog",
  "aria-modal": "true",
  "aria-labelledby": "nge-reset-title",
  "aria-describedby": "nge-reset-what"
}
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "nge-reset-title",
  class: "nge-settings-reset-title"
}, "⚠ Restore all settings to default?", -1 /* HOISTED */))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "nge-reset-what",
  class: "nge-settings-reset-text"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "Every setting goes back to how Pyr starts, on this computer and on your account, so on your other computers too. This includes:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "your toolbar icons and their order"),
    /*#__PURE__*/_createElementVNode("li", null, "chat, music and notification choices"),
    /*#__PURE__*/_createElementVNode("li", null, "your Highlight colors"),
    /*#__PURE__*/_createElementVNode("li", null, "viewer settings and 2D image detail"),
    /*#__PURE__*/_createElementVNode("li", null, "extra datasets you turned on, and your own start views")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Your flag, your bio, your cells and your progress are not touched. Pyr reloads afterwards. This cannot be undone.")
], -1 /* HOISTED */))
const _hoisted_194 = {
  key: 0,
  class: "nge-settings-reset-error"
}
const _hoisted_195 = { class: "nge-settings-reset-btns" }
const _hoisted_196 = ["disabled"]
const _hoisted_197 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.embedded ? 'div' : $setup.ModalOverlay), {
    id: $setup.props.embedded ? undefined : 'nge-settings-modal',
    class: _normalizeClass($setup.props.embedded ? 'nge-settings-embedded' : 'nge-settings-modal'),
    onHide: _cache[86] || (_cache[86] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["nge-settings-shell", { 'nge-settings-shell--embedded': $setup.props.embedded }])
      }, [
        _createCommentVNode(" Top bar "),
        (!$setup.props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("button", {
                class: "nge-settings-exit",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
              }, "×")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Settings content "),
        _createElementVNode("div", _hoisted_3, [
          _createCommentVNode(" Admins: see the game as a player does (Ames 2026-10-25). Display\n             only and instant, so no Save: admin powers stay, and the\n             \"Player view\" chip in the top bar switches back. "),
          ($setup.backendStore.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    role: "radio",
                    "aria-checked": !$setup.backendStore.playerView,
                    class: _normalizeClass({ 'is-on': !$setup.backendStore.playerView }),
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.backendStore.setPlayerView(false)))
                  }, "Admin", 10 /* CLASS, PROPS */, _hoisted_7),
                  _createElementVNode("button", {
                    type: "button",
                    role: "radio",
                    "aria-checked": $setup.backendStore.playerView,
                    class: _normalizeClass({ 'is-on': $setup.backendStore.playerView }),
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.backendStore.setPlayerView(true)))
                  }, "Player", 10 /* CLASS, PROPS */, _hoisted_8)
                ]),
                _hoisted_9
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Three columns in the profile (Ames 2026-09-29: \"larger, full profile\n             size, a cool layout, keep it scifi\"). In the stand-alone window\n             the column wrappers are display: contents, so it stays one list. "),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createCommentVNode(" Username lives at the bottom and is deliberately NOT an always-live\n               text field: it's how everyone tags you, so changing it should be a\n               deliberate act. Show the current handle read-only; the actual edit\n               happens in the dedicated dialog (validation + availability check),\n               opened by the button. `force` bypasses the dialog's \"ask once\"\n               guards so it works when you already have a handle. "),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--username", { 'nge-set-folded': $setup.isFolded('username') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('username'),
                title: "Fold or unfold this box",
                onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.toggleFold('username')), ["prevent"])),
                onKeydown: [
                  _cache[4] || (_cache[4] = _withKeys(_withModifiers($event => ($setup.toggleFold('username')), ["prevent"]), ["enter"])),
                  _cache[5] || (_cache[5] = _withKeys(_withModifiers($event => ($setup.toggleFold('username')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Username"),
                _hoisted_13
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                  class: _normalizeClass(["nge-settings-username-current", { 'nge-settings-username-current--empty': !$setup.backendStore.username }])
                }, _toDisplayString($setup.backendStore.username ? '@' + $setup.backendStore.username : 'No username set yet'), 3 /* TEXT, CLASS */),
                _createElementVNode("button", {
                  class: "nge-settings-username-btn",
                  onClick: $setup.openUsernameDialog
                }, _toDisplayString($setup.backendStore.username ? 'Change username…' : 'Pick a username…'), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--flag", { 'nge-set-folded': $setup.isFolded('flag') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('flag'),
                title: "Fold or unfold this box",
                onClick: _cache[6] || (_cache[6] = _withModifiers($event => ($setup.toggleFold('flag')), ["prevent"])),
                onKeydown: [
                  _cache[7] || (_cache[7] = _withKeys(_withModifiers($event => ($setup.toggleFold('flag')), ["prevent"]), ["enter"])),
                  _cache[8] || (_cache[8] = _withKeys(_withModifiers($event => ($setup.toggleFold('flag')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Country / Flag"),
                _hoisted_17
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16),
              _hoisted_18,
              _createElementVNode("div", {
                id: "nge-settings-country-wrap",
                class: "nge-settings-country-wrap",
                onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("button", {
                  class: "nge-settings-country-btn",
                  onClick: _cache[9] || (_cache[9] = $event => ($setup.showCountryList = !$setup.showCountryList))
                }, [
                  _createElementVNode("span", _hoisted_19, [
                    ($setup.draftFlag === 'eyewire')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pyrIcon,
                          class: "nge-settings-country-flag-img nge-settings-country-flag-img--logo"
                        }, null, 8 /* PROPS */, _hoisted_20))
                      : ($setup.flagImgUrl($setup.draftFlag))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: $setup.flagImgUrl($setup.draftFlag),
                            class: "nge-settings-country-flag-img"
                          }, null, 8 /* PROPS */, _hoisted_21))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "🌐"))
                  ]),
                  _createElementVNode("span", _hoisted_23, _toDisplayString($setup.selectedCountry?.name || 'Choose a country'), 1 /* TEXT */),
                  _hoisted_24
                ]),
                ($setup.showCountryList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.countrySearch) = $event)),
                        type: "text",
                        class: "nge-settings-country-search",
                        placeholder: "Search country...",
                        autocomplete: "off",
                        spellcheck: "false",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.countrySearch]
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCountries, (c) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: c.code,
                            class: _normalizeClass(["nge-settings-country-opt", { 'nge-settings-country-opt--active': $setup.draftFlag === c.code }]),
                            onClick: $event => ($setup.selectCountry(c.code))
                          }, [
                            _createElementVNode("span", _hoisted_28, [
                              (c.code === 'eyewire')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: $setup.pyrIcon,
                                    class: "nge-settings-country-flag-img nge-settings-country-flag-img--logo"
                                  }, null, 8 /* PROPS */, _hoisted_29))
                                : ($setup.flagImgUrl(c.code))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: $setup.flagImgUrl(c.code),
                                      class: "nge-settings-country-flag-img"
                                    }, null, 8 /* PROPS */, _hoisted_30))
                                  : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(c.name), 1 /* TEXT */)
                          ], 10 /* CLASS, PROPS */, _hoisted_27))
                        }), 128 /* KEYED_FRAGMENT */)),
                        ($setup.filteredCountries.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "No matches"))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--bio", { 'nge-set-folded': $setup.isFolded('bio') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('bio'),
                title: "Fold or unfold this box",
                onClick: _cache[13] || (_cache[13] = _withModifiers($event => ($setup.toggleFold('bio')), ["prevent"])),
                onKeydown: [
                  _cache[14] || (_cache[14] = _withKeys(_withModifiers($event => ($setup.toggleFold('bio')), ["prevent"]), ["enter"])),
                  _cache[15] || (_cache[15] = _withKeys(_withModifiers($event => ($setup.toggleFold('bio')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Bio"),
                _hoisted_34
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_33),
              _hoisted_35,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.draftBio) = $event)),
                class: "nge-settings-textarea",
                maxlength: "280",
                rows: "4",
                placeholder: "e.g. PhD student at MIT. Loves connectomics and cold brew."
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.draftBio]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["nge-settings-charcount", { 'nge-settings-charcount--warn': $setup.draftBio.length > 250 }])
              }, _toDisplayString($setup.draftBio.length) + " / 280", 3 /* TEXT, CLASS */)
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--notif", { 'nge-set-folded': $setup.isFolded('notif') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('notif'),
                title: "Fold or unfold this box",
                onClick: _cache[17] || (_cache[17] = _withModifiers($event => ($setup.toggleFold('notif')), ["prevent"])),
                onKeydown: [
                  _cache[18] || (_cache[18] = _withKeys(_withModifiers($event => ($setup.toggleFold('notif')), ["prevent"]), ["enter"])),
                  _cache[19] || (_cache[19] = _withKeys(_withModifiers($event => ($setup.toggleFold('notif')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Chat and notifications"),
                _hoisted_37
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_36),
              _hoisted_38,
              _createElementVNode("label", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.draftChatMuted) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftChatMuted]
                ]),
                _hoisted_40
              ]),
              _createElementVNode("label", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (($setup.draftChatFade) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftChatFade]
                ]),
                _hoisted_42
              ]),
              _createElementVNode("label", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (($setup.draftChatMarkMine) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftChatMarkMine]
                ]),
                _hoisted_44
              ]),
              _createElementVNode("label", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($setup.draftHelpMuted) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftHelpMuted]
                ]),
                _hoisted_46
              ]),
              _createElementVNode("label", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (($setup.draftUndeleteCounter) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftUndeleteCounter]
                ]),
                _hoisted_48
              ])
            ], 2 /* CLASS */),
            _createCommentVNode(" On the left, with who you are (Ames 2026-10-29: \"switching datasets should be on the left\"). "),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--datasets", { 'nge-set-folded': $setup.isFolded('datasets') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('datasets'),
                title: "Fold or unfold this box",
                onClick: _cache[25] || (_cache[25] = _withModifiers($event => ($setup.toggleFold('datasets')), ["prevent"])),
                onKeydown: [
                  _cache[26] || (_cache[26] = _withKeys(_withModifiers($event => ($setup.toggleFold('datasets')), ["prevent"]), ["enter"])),
                  _cache[27] || (_cache[27] = _withKeys(_withModifiers($event => ($setup.toggleFold('datasets')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Switching datasets"),
                _hoisted_50
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_49),
              _hoisted_51,
              _createElementVNode("label", _hoisted_52, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (($setup.draftBareSwitch) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftBareSwitch]
                ]),
                _hoisted_53
              ]),
              _hoisted_54,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONAL_DATASETS, (ds) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: ds.id,
                  class: "nge-settings-toggle nge-sv-extra"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: $setup.draftExtra.includes(ds.id),
                    onChange: $event => ($setup.toggleDraftExtra(ds.id, $event))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_55),
                  _createElementVNode("span", _hoisted_56, _toDisplayString(ds.label), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (($setup.svDataset) = $event)),
                  class: "nge-sv-select",
                  onChange: $setup.pickStartViewDataset
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.DATASETS, (ds) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: ds.id,
                      value: $setup.segLayerName(ds)
                    }, _toDisplayString(ds.label), 9 /* TEXT, PROPS */, _hoisted_59))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelSelect, $setup.svDataset]
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => (($setup.svLink) = $event)),
                  class: "nge-sv-input",
                  type: "url",
                  placeholder: "Paste a share link",
                  onKeydown: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"])),
                  onKeyup: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelText, $setup.svLink]
                ]),
                _createElementVNode("button", {
                  class: "nge-sv-btn",
                  type: "button",
                  onClick: $setup.setStartView
                }, "Use this view")
              ]),
              ($setup.svError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString($setup.svError), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (Object.keys($setup.draftStartViews).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_62, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draftStartViews, (link, seg) => {
                      return (_openBlock(), _createElementBlock("li", { key: seg }, [
                        _createElementVNode("span", _hoisted_63, _toDisplayString($setup.labelFor(String(seg))), 1 /* TEXT */),
                        _createElementVNode("span", {
                          class: "nge-sv-link",
                          title: link
                        }, _toDisplayString(link), 9 /* TEXT, PROPS */, _hoisted_64),
                        _createElementVNode("button", {
                          class: "nge-sv-clear",
                          type: "button",
                          onClick: $event => ($setup.clearStartView(String(seg)))
                        }, "Remove", 8 /* PROPS */, _hoisted_65)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_66
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--toolbar", { 'nge-set-folded': $setup.isFolded('toolbar') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('toolbar'),
                title: "Fold or unfold this box",
                onClick: _cache[33] || (_cache[33] = _withModifiers($event => ($setup.toggleFold('toolbar')), ["prevent"])),
                onKeydown: [
                  _cache[34] || (_cache[34] = _withKeys(_withModifiers($event => ($setup.toggleFold('toolbar')), ["prevent"]), ["enter"])),
                  _cache[35] || (_cache[35] = _withKeys(_withModifiers($event => ($setup.toggleFold('toolbar')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Toolbar Icons"),
                _hoisted_70
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_69),
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.TOOLBAR_ICON_OPTIONS, (opt) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: opt.id,
                    class: _normalizeClass(["nge-settings-toolbar-item", { 'nge-settings-toolbar-item--active': $setup.isToolbarIconEnabled(opt.id) }]),
                    title: opt.label,
                    onClick: $event => ($setup.toggleToolbarIcon(opt.id))
                  }, [
                    (opt.svg)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "nge-settings-toolbar-emoji",
                          innerHTML: opt.svg
                        }, null, 8 /* PROPS */, _hoisted_74))
                      : (opt.img)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: opt.img,
                            class: "nge-settings-toolbar-icon-img",
                            alt: opt.label
                          }, null, 8 /* PROPS */, _hoisted_75))
                        : (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(opt.emoji), 1 /* TEXT */)),
                    _createElementVNode("span", _hoisted_77, _toDisplayString($setup.pillName(opt.label)), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_73))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("button", {
                class: "nge-settings-toolbar-reset",
                onClick: $setup.resetToolbar
              }, "Reset to defaults")
            ], 2 /* CLASS */),
            _createCommentVNode(" The old User Interface card, split into small cards by topic\n               (Ames 2026-10-24: \"need to better organize these\"). Annotation\n               point size is not here: it is set on the annotation layer itself. "),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--look", { 'nge-set-folded': $setup.isFolded('look') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('look'),
                title: "Fold or unfold this box",
                onClick: _cache[36] || (_cache[36] = _withModifiers($event => ($setup.toggleFold('look')), ["prevent"])),
                onKeydown: [
                  _cache[37] || (_cache[37] = _withKeys(_withModifiers($event => ($setup.toggleFold('look')), ["prevent"]), ["enter"])),
                  _cache[38] || (_cache[38] = _withKeys(_withModifiers($event => ($setup.toggleFold('look')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("3D looks"),
                _hoisted_79
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_78),
              _hoisted_80,
              _createElementVNode("label", _hoisted_81, [
                _hoisted_82,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => (($setup.draftHoverStyle) = $event)),
                  class: "nge-sv-select"
                }, _hoisted_91, 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.draftHoverStyle]
                ])
              ]),
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("div", _hoisted_94, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.PULSE_COLORS, (c) => {
                    return _createElementVNode("button", {
                      key: c.value,
                      type: "button",
                      class: _normalizeClass(["nge-pulse-swatch", { 'nge-pulse-swatch--own': !c.value, 'nge-pulse-swatch--on': $setup.draftPulseColor === c.value }]),
                      style: _normalizeStyle(c.value ? { background: c.value } : undefined),
                      title: c.label,
                      "aria-label": c.label,
                      onClick: $event => ($setup.draftPulseColor = c.value)
                    }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_95)
                  }), 64 /* STABLE_FRAGMENT */)),
                  _createElementVNode("label", {
                    class: _normalizeClass(["nge-pulse-swatch nge-pulse-swatch--pick", { 'nge-pulse-swatch--on': $setup.isCustomPulseColor }]),
                    style: _normalizeStyle($setup.isCustomPulseColor ? { background: $setup.draftPulseColor } : undefined),
                    title: "Any colour"
                  }, [
                    _createElementVNode("input", {
                      type: "color",
                      value: $setup.draftPulseColor || '#59d8ff',
                      onInput: $setup.onPulseColorPick
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_96)
                  ], 6 /* CLASS, STYLE */)
                ])
              ]),
              _hoisted_97,
              ($setup.pumpkinSeason())
                ? (_openBlock(), _createElementBlock("label", _hoisted_98, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => (($setup.draftPumpkin) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, $setup.draftPumpkin]
                    ]),
                    _hoisted_99
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--screen", { 'nge-set-folded': $setup.isFolded('screen') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('screen'),
                title: "Fold or unfold this box",
                onClick: _cache[41] || (_cache[41] = _withModifiers($event => ($setup.toggleFold('screen')), ["prevent"])),
                onKeydown: [
                  _cache[42] || (_cache[42] = _withKeys(_withModifiers($event => ($setup.toggleFold('screen')), ["prevent"]), ["enter"])),
                  _cache[43] || (_cache[43] = _withKeys(_withModifiers($event => ($setup.toggleFold('screen')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Screen"),
                _hoisted_101
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_100),
              _hoisted_102,
              _createElementVNode("label", _hoisted_103, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => (($setup.draftCellCelebration) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftCellCelebration]
                ]),
                _hoisted_104
              ]),
              _createElementVNode("label", _hoisted_105, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => (($setup.draftAchievementCelebration) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftAchievementCelebration]
                ]),
                _hoisted_106
              ]),
              _createElementVNode("label", _hoisted_107, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => (($setup.draftNotifCategories) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftNotifCategories]
                ]),
                _hoisted_108
              ]),
              _createElementVNode("label", _hoisted_109, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => (($setup.draftDailyDigest) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftDailyDigest]
                ]),
                _hoisted_110
              ]),
              _createElementVNode("label", _hoisted_111, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => (($setup.draftParticles) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftParticles]
                ]),
                _hoisted_112
              ]),
              _createElementVNode("label", _hoisted_113, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => (($setup.draftCalm) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftCalm]
                ]),
                _hoisted_114
              ]),
              _createElementVNode("label", _hoisted_115, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => (($setup.draftCursorXL) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftCursorXL]
                ]),
                _hoisted_116
              ]),
              _createElementVNode("label", _hoisted_117, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => (($setup.draftLargeText) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftLargeText]
                ]),
                _hoisted_118
              ]),
              _createElementVNode("label", _hoisted_119, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => (($setup.draftHideTopBar) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftHideTopBar]
                ]),
                _hoisted_120
              ]),
              _createElementVNode("label", _hoisted_121, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => (($setup.draftSegShowId) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftSegShowId]
                ]),
                _hoisted_122
              ]),
              _createElementVNode("label", _hoisted_123, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => (($setup.draftShowRadio) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftShowRadio]
                ]),
                _hoisted_124
              ])
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("div", _hoisted_125, [
            _hoisted_126,
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--jump", { 'nge-set-folded': $setup.isFolded('jump') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('jump'),
                title: "Fold or unfold this box",
                onClick: _cache[55] || (_cache[55] = _withModifiers($event => ($setup.toggleFold('jump')), ["prevent"])),
                onKeydown: [
                  _cache[56] || (_cache[56] = _withKeys(_withModifiers($event => ($setup.toggleFold('jump')), ["prevent"]), ["enter"])),
                  _cache[57] || (_cache[57] = _withKeys(_withModifiers($event => ($setup.toggleFold('jump')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Jumping and views"),
                _hoisted_128
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_127),
              _hoisted_129,
              _createElementVNode("label", _hoisted_130, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => (($setup.draftJumpAdds) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftJumpAdds]
                ]),
                _hoisted_131
              ]),
              _createElementVNode("label", _hoisted_132, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => (($setup.draftKeepDisplay) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftKeepDisplay]
                ]),
                _hoisted_133
              ]),
              _createElementVNode("label", _hoisted_134, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => (($setup.draftOfferRestore) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftOfferRestore]
                ]),
                _hoisted_135
              ]),
              _createElementVNode("label", _hoisted_136, [
                _hoisted_137,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => (($setup.draftLibraryTab) = $event)),
                  class: "nge-sv-select"
                }, _hoisted_144, 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.draftLibraryTab]
                ])
              ])
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--images", { 'nge-set-folded': $setup.isFolded('images') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('images'),
                title: "Fold or unfold this box",
                onClick: _cache[62] || (_cache[62] = _withModifiers($event => ($setup.toggleFold('images')), ["prevent"])),
                onKeydown: [
                  _cache[63] || (_cache[63] = _withKeys(_withModifiers($event => ($setup.toggleFold('images')), ["prevent"]), ["enter"])),
                  _cache[64] || (_cache[64] = _withKeys(_withModifiers($event => ($setup.toggleFold('images')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("2D images"),
                _hoisted_146
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_145),
              _hoisted_147,
              _createElementVNode("label", _hoisted_148, [
                _hoisted_149,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => (($setup.draftImageDetail) = $event)),
                  class: "nge-sv-select"
                }, _hoisted_153, 512 /* NEED_PATCH */), [
                  [
                    _vModelSelect,
                    $setup.draftImageDetail,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("label", _hoisted_154, [
                _hoisted_155,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = $event => (($setup.draftImageSource) = $event)),
                  class: "nge-sv-select"
                }, [
                  _createElementVNode("option", _hoisted_156, "Automatic (" + _toDisplayString($setup.autoImageRegion) + ")", 1 /* TEXT */),
                  _hoisted_157,
                  _hoisted_158
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.draftImageSource]
                ])
              ])
            ], 2 /* CLASS */),
            _createCommentVNode(" Everything that brings back neuroglancer's own way of working, in\n               one place for players who know it from before (Ames 2026-10-25).\n               Took over the Advanced card. Named Neuroglancer, with an (i)\n               saying what that is (Ames 2026-10-25). "),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-section nge-set-card--classic", { 'nge-set-folded': $setup.isFolded('classic') }])
            }, [
              _createElementVNode("label", {
                class: "nge-settings-label nge-set-fold",
                role: "button",
                tabindex: "0",
                "aria-expanded": !$setup.isFolded('classic'),
                title: "Fold or unfold this box",
                onClick: _cache[70] || (_cache[70] = _withModifiers($event => ($setup.toggleFold('classic')), ["prevent"])),
                onKeydown: [
                  _cache[71] || (_cache[71] = _withKeys(_withModifiers($event => ($setup.toggleFold('classic')), ["prevent"]), ["enter"])),
                  _cache[72] || (_cache[72] = _withKeys(_withModifiers($event => ($setup.toggleFold('classic')), ["prevent"]), ["space"]))
                ]
              }, [
                _createTextVNode("Neuroglancer"),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["nge-set-info", { 'nge-set-info--on': $setup.ngInfoOpen }]),
                  "aria-label": "What is neuroglancer?",
                  "aria-expanded": $setup.ngInfoOpen,
                  title: "What is neuroglancer?",
                  onClick: _cache[67] || (_cache[67] = _withModifiers($event => ($setup.ngInfoOpen = !$setup.ngInfoOpen), ["stop","prevent"])),
                  onKeydown: [
                    _cache[68] || (_cache[68] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])),
                    _cache[69] || (_cache[69] = _withKeys(_withModifiers(() => {}, ["stop"]), ["space"]))
                  ]
                }, "i", 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_160),
                _hoisted_161
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_159),
              ($setup.ngInfoOpen)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "nge-set-info-pop",
                    role: "dialog",
                    "aria-label": "What is neuroglancer?",
                    onClick: _cache[74] || (_cache[74] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-set-info-x",
                      "aria-label": "Close",
                      onClick: _cache[73] || (_cache[73] = $event => ($setup.ngInfoOpen = false))
                    }, "×"),
                    _hoisted_162,
                    _hoisted_163,
                    _hoisted_164
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_165,
              _createElementVNode("label", _hoisted_166, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => (($setup.draftAnnotationGems) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftAnnotationGems]
                ]),
                _hoisted_167
              ]),
              _createElementVNode("label", _hoisted_168, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => (($setup.draftClassicLayers) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftClassicLayers]
                ]),
                _hoisted_169
              ]),
              _createElementVNode("label", _hoisted_170, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => (($setup.draftImageLayerPanel) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftImageLayerPanel]
                ]),
                _hoisted_171
              ]),
              _createElementVNode("label", _hoisted_172, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = $event => (($setup.draftAnnotationSetupTabs) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftAnnotationSetupTabs]
                ]),
                _hoisted_173
              ]),
              _createElementVNode("label", _hoisted_174, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[79] || (_cache[79] = $event => (($setup.draftSegSetupTabs) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftSegSetupTabs]
                ]),
                _hoisted_175
              ]),
              _createElementVNode("label", _hoisted_176, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[80] || (_cache[80] = $event => (($setup.draftShowNgControls) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftShowNgControls]
                ]),
                _hoisted_177
              ]),
              _createElementVNode("label", _hoisted_178, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[81] || (_cache[81] = $event => (($setup.draftShowXyz) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.draftShowXyz]
                ]),
                _hoisted_179
              ]),
              _createElementVNode("div", { style: {"display":"grid","grid-template-columns":"repeat(2, 1fr)","gap":"8px"} }, [
                _createElementVNode("button", {
                  class: "nge-settings-advanced-btn",
                  onClick: $setup.openNgSettings
                }, "⚙ Viewer Settings"),
                _createElementVNode("button", {
                  class: "nge-settings-advanced-btn",
                  onClick: $setup.openJsonEditor
                }, "{} Edit JSON State"),
                _createElementVNode("button", {
                  class: "nge-settings-advanced-btn",
                  onClick: $setup.toggleLayerListPanel
                }, "☰ Layer List Panel"),
                _createElementVNode("button", {
                  class: "nge-settings-advanced-btn",
                  onClick: $setup.toggleSelectionDetails
                }, "◫ Selection Details")
              ]),
              _hoisted_180,
              _createCommentVNode(" Logins management "),
              ($setup.loginStore.sessions.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                    _hoisted_182,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loginStore.sessions, (session) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: session.hostname,
                        class: "nge-settings-login-row"
                      }, [
                        _createElementVNode("div", _hoisted_183, [
                          _createElementVNode("span", _hoisted_184, _toDisplayString(session.email || 'Unknown'), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_185, _toDisplayString(session.hostname), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                          class: "nge-settings-logout-btn",
                          onClick: $event => ($setup.logoutSession(session))
                        }, "Logout", 8 /* PROPS */, _hoisted_186)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ])
        ]),
        _createCommentVNode(" Pinned footer: moved OUT of .nge-settings-content so Save stays\n           reachable on short screens. Previously it scrolled with the body,\n           and on a small laptop the whole panel simply overflowed the viewport\n           with no scrollbar, putting Save off-screen entirely. "),
        _createElementVNode("div", _hoisted_187, [
          _createElementVNode("button", {
            class: "nge-settings-save",
            onClick: $setup.handleSave
          }, [
            ($setup.saved)
              ? (_openBlock(), _createElementBlock("span", _hoisted_188, "✓ Saved!"))
              : (_openBlock(), _createElementBlock("span", _hoisted_189, "Save"))
          ]),
          (!$setup.props.embedded)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "nge-settings-cancel",
                onClick: _cache[82] || (_cache[82] = $event => ($setup.emit('hide')))
              }, "Cancel"))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_190, [
          _createElementVNode("button", {
            class: "nge-settings-reset",
            type: "button",
            onClick: _cache[83] || (_cache[83] = $event => ($setup.confirmReset = true))
          }, "Restore all settings to default")
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          ($setup.confirmReset)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-settings-reset-backdrop",
                onClick: _cache[85] || (_cache[85] = _withModifiers($event => (!$setup.resetting && ($setup.confirmReset = false)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_191, [
                  _hoisted_192,
                  _hoisted_193,
                  ($setup.resetError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_194, _toDisplayString($setup.resetError), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_195, [
                    _createElementVNode("button", {
                      class: "nge-settings-cancel",
                      type: "button",
                      disabled: $setup.resetting,
                      onClick: _cache[84] || (_cache[84] = $event => ($setup.confirmReset = false))
                    }, "Keep my settings", 8 /* PROPS */, _hoisted_196),
                    _createElementVNode("button", {
                      class: "nge-settings-reset nge-settings-reset--go",
                      type: "button",
                      disabled: $setup.resetting,
                      onClick: $setup.restoreDefaults
                    }, _toDisplayString($setup.resetting ? 'Restoring…' : 'Restore defaults'), 9 /* TEXT, PROPS */, _hoisted_197)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 40 /* PROPS, HYDRATE_EVENTS */, ["id", "class"]))
}